var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"progress-bar",attrs:{"data-size":_vm.small ? 'small' : ''}},[_c('span',{staticClass:"progress-bar__fill",style:({ width: _vm.fillPercent })})])
}
var staticRenderFns = []

export { render, staticRenderFns }